import script from "./ChatAgentV3.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatAgentV3.vue?vue&type=script&setup=true&lang=js"

import "./ChatAgentV3.vue?vue&type=style&index=0&id=477e78bf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-477e78bf"]])

export default __exports__